import React from "react";
import reactDom from "react-dom";
import "./styles/global.css";
import App from "./App";
reactDom.render(<App />, document.getElementById("root"));
